GP.GPMod('Page',function(self) {
    var first_route       = true;
    var initial_page_load = true;
    var default_url  = '/members/user/home/';
    var skip_targets = ['_blank','_new'];
    var hit_routes   = [];
    var skip_microstate_check = false;
    var notneeded = false; // make sure the minified file changes, not really needed
    var user_profile_regex = /user(\/|\.)profile/g;

    var router = Backbone.Router.extend({
        initialize: function () {
            // When app initializes there are no hitRoutes
            hit_routes = [];

            if (typeof window.onpopstate != 'undefined') {
                window.onpopstate = function (event) {
                    Backbone.trigger('popstate', event);
                };
                this.listenTo(Backbone, 'popstate', this.popstate);
            }
        },
        // handler that's called when the back button is hit, and the state will be checked and appropriate actions taken
        popstate: function(event) {
            // safari and some older browsers fire popstate event on page load, which isn't what we want, so override first call
            if (initial_page_load) {
                initial_page_load = false;
                return;
            }

            var state = event.state || {};
            var current_url = (window.location.pathname + window.location.search).toLowerCase();

            // dispose of videochat stream if we were viewing one on mobile back button (but not for profile streaming)
            if (MoshPit.get_size() == 'mobile' && current_url.indexOf('user/profile') === -1) {
                GP.vent.trigger('VChat:abort');
            }

            // pop the history stack if there is a state which would require an action, but not in mobile screen size
            if (MoshPit.get_size() != 'mobile' && (state.right_drawer || state.thread_open || state.modal)) {
                window.history.back();
                return;
            // trigger the default initial filter.  No pushstate is set for the initial load
            } else if (current_url.indexOf('trending') !== -1 && _.isEmpty(state)) {
                // GP.vent.trigger('ContentTrending:filter');
            } else if (MoshPit.get_size() != 'mobile' && !state.trending && _.isEmpty(state)) {
                return;
            }

            // if we have any right_drawer state, trigger that pane if it's not the current one
            // otherwise, close the right drawer
            if (state.right_drawer) {
                if (!MoshPit.is_shown(state.right_drawer)) {
                    GP.vent.trigger("RightDrawer:show", state.right_drawer, true);
                }
            } /*else if (state.mobile_menu) {
                if (!MoshPit.is_shown('mobile-menu')) {
                    GP.vent.trigger("Header:open_mobile_menu", true);
                }
            } */else if (state.chat) {
                if (state.chat == 'chat-rooms') {
                    GP.vent.trigger('Chat:show_mobile_chat_rooms', true);
                } else if (state.chat == 'chat-main') {
                    GP.vent.trigger('Chat:show_mobile_chat_main', true);
                } else if (state.chat == 'chat-users') {
                    // trigger show chat users
                    GP.vent.trigger('Chat:show_mobile_chat_users', true);
                }

                GP.vent.trigger("RightDrawer:hide");
            } else if (MoshPit.get_size() == 'mobile'){
                GP.vent.trigger("RightDrawer:hide");
                // GP.vent.trigger("Header:close_mobile_menu", true);
            }
            // close thread if we don't have a thread microstate
            if (!state.thread_open) {
                 GP.vent.trigger('ThreadLayout:close');
            } else {
                // if we don't have the thread_id/duid, gtfo
                if (!state.thread_open.thread_id || !state.thread_open.duid) {
                    return;
                }
                var thread_model;

                // try to grab thread model from shared data
                if (GP.sdata && GP.sdata.MessagingThreads) {
                    thread_model = GP.sdata.MessagingThreads.get(state.thread_open.thread_id);
                }

                // if we have the thread_model already, then just use it
                if (thread_model) {
                    var models = {
                        user:   GP.sdata.MessagingUsers.get(thread_model.get('other_duid')),
                        thread: thread_model,
                    };
                    GP.vent.trigger("RightDrawer:show", 'MessagePane', true);
                    GP.vent.trigger('MessagePane.Thread:create_thread', models, true);
                } else {
                    // if we don't, then grab the thread_json and call load_thread_external
                    var user_model = new GP.models.User({duid: state.thread_open.duid});
                    user_model.thread_json()
                        .done(function(thread_json) {
                            if (GP.Util.check_obj(thread_json)) {
                                // GP.vent.trigger("RightDrawer:show", 'MessagePane', true);
                                GP.vent.trigger('MessagePane.Inbox:load_thread_external', thread_json, true);
                            }
                        })
                        .fail(function() {
                            // maybe close right drawer here if we fail to get the thread_json?
                        });
                }
            }

            // trigger trending filter
            if (state.trending) {
                GP.vent.trigger('ContentTrending:filter', state.trending);
            }

            // trigger the content modal
            if (state.content_viewer) {
                var modal_url = GP.Util.clean_url('/members/content/viewer/', {
                    duid: state.duid,
                    content_id: state.content_id,
                });

                GP.vent.trigger('Modal:open', {
                    url: modal_url
                });
            }

            // close modal if we don't have a modal microstate
            if (!state.modal) {
                 GP.vent.trigger('Modal:close');
            }
        },
        // This function is called when a popstate event occurs before a route handler is invoked.
        // If false is returned, the route handler will not be called, if true, it will.
        before: function () {
            if (MoshPit.get_size() != 'mobile') {
                return true;
            }
            var currentUrl = window.location.pathname + window.location.search;
            // If the new state is a microstate,
            // don't process it via the corresponding route handler
            if (!skip_microstate_check && hit_routes.length > 0 && _.last(hit_routes) === currentUrl) {
                return false;

            // If the user goes back, remove the last hitRoute so that
            // hitRoutes has the correct record of history
            } else if (hit_routes.length > 1 && currentUrl === hit_routes[hit_routes.length - 2]) {
                hit_routes.pop();

            // By default add the URL to the array of hit routes
            } else {
                hit_routes.push(currentUrl);
            }
            return true;
        },
        routes: {
            "*url":'default_route'
        },
        default_route: function(path, query) {
            // if we have a trigger=inbox query param, open up the message pane (inbox)
            if (query) {
                if (query.indexOf('trigger=inbox') > -1) {

                    // set the inbox filter if we have the inbox_filter param
                    if (query.indexOf('inbox_filter=') > -1) {
                        var filter_matches = /inbox_filter=([^&]+)/.exec(query);
                        var inbox_filter   = (filter_matches && filter_matches[1]) ? filter_matches[1] : null;

                        if (inbox_filter) {
                            self.vent.trigger("MessagePane.Inbox:change_filter", inbox_filter);
                        }
                    }

                    // show the message pane
                    self.vent.trigger("RightDrawer:show", {pane: 'message-pane'});

                } else if (query.indexOf('trigger=friend_requests') > -1) {
                    self.vent.trigger("RightDrawer:show", {pane: 'friend-pane'});
                }
            }

            // open mobile-menu after toggling safemode in nav menu.
            if (first_route && window.sessionStorage && window.sessionStorage.getItem('open_mobile_menu')) {
                GP.vent.trigger("Header:open_mobile_menu", true);
                window.sessionStorage.removeItem('open_mobile_menu');
            }

            // don't trigger the standard route on the first time (page load), since we don't need to grab via ajax
            if (first_route) {
                first_route = false;
                return;
            }

            // THIS HAS TO HAPPEN FOR EVERY PAGE CHANGE! (do not redirect or return before this)
            util.handle_messaging();

            // TODO: handle this better.
            // I'm adding jump-page state to jump pages (so we can show/hide things),
            // which happens after the default_route is called, so remove it first, and it will get added if needed
            MoshPit.remove_state('jump-page').remove_state('mobile-chat-main').remove_state('mobile-chat-users');

            // Remove scrolltop button event
            self.vent.trigger('Profile:remove_scrolltop_button');

            query = (query === null) ? '' : '?' + query;
            var fetch_url = '/' + path + query;

            // google analytics
            if (typeof ga !== 'undefined') {
                ga('send', 'pageview', {
                    'page': fetch_url
                });
            }
            var cached = page_cache.get(fetch_url);
            if (cached !== false) {
                events.update_page(cached);
            } else {
                apis.fetch_page(fetch_url);
            }

            // zendesk chat widget
            if (typeof zE !== 'undefined') {
                zE('webWidget', 'hide');
            }

        }
    });



    var apis = {
        fetch_page: function(url) {
            self.api.json(url, {
                data:    {},
                no_parse_url: true,
                success: events.page_response,
                error:   events.page_error,
                beforeSend: util.show_overlay
            });
        }
    };

    var util = {
        init: function() {
            GP.reqres.setHandler('Page:can_show_popups', util.can_show_popups);
            util.set_scrolling();
        },
        // removes the domain part of a protocol-less url
        // i.e. "//www.fling.com/members/user/home/" returns "/members/user/home/"
        remove_domain: function(url) {
            // not a protocol-less url, return url input
            if (url.substring(0,2) !== '//') {
                return url;
            }
            var index = url.indexOf("/",2);
            return url.substring(index);
        },
        // scrub no_base_template parameter
        scrub_template_param: function(url) {
            if (typeof url !== 'undefined') {
                return url.replace('&no_base_template=true','');
            }
        },
        // handle redirecting https to http unless profile page (which other JS modules will handle)
        handle_https: function(url) {
            if (GP.Util.test_https() && !user_profile_regex.test(url)) {
                var current_url = window.location.href;
                var http_url = current_url.replace('https://', 'http://');

                window.location.href = http_url;
                return;
            }
        },
        // test scrollable content
        page_is_scrollable: function() {
            return ($('#main').prop('scrollHeight') > $('#main').innerHeight());
        },
        // add/rem scrollable state
        set_scrolling: function() {
            if (util.page_is_scrollable()) {
                MoshPit.add_state('scrolling-content');
            } else {
                MoshPit.remove_state('scrolling-content');
            }
        },
        show_overlay: function() {
            $('#loading-overlay').show();
        },
        hide_overlay: function() {
            $('#loading-overlay').hide();
        },
        // minimize/close the all threads for any page changes (even if we're on the page we're navigating to)
        handle_messaging: function() {
            if (MoshPit.get_size() != 'mobile') {
                // if our thred-view pref is set to maximized mode, close maximized thread
                if (GP.sdata.thread_style != 2) {
                    GP.vent.trigger('ThreadLayout:close', { only_maximized: true });
                } else {
                    // else just minize only the maximized thread (to get it out of our way)
                    GP.vent.trigger('ThreadLayout:minimize', { only_full: true });
                }
            } else {
                var check_nested = self.app.Util.check_nested;

                // don't close rightdrawer/thread if we have a state of right_drawer or thread_open
                if (check_nested(window, 'history.state.right_drawer') || check_nested(window, 'history.state.thread_open')) {
                    // maybe do something if a right drawer/thread_open state was found
                    // but that is being handled in the popstate handler... we just need to not undo it
                } else {
                    GP.vent.trigger('ThreadLayout:close');
                    GP.vent.trigger('RightDrawer:hide');
                }
            }
        },
        can_show_popups: function() {
            var no_popups_pages = ['/user/register_success', '/user/jump_', '/user/edit_user_profile',
             '/user/edit_account', '/user/help', '/billing/', 'modal'];
            var popups_allowed = true;
            _.each(no_popups_pages, function(page) {
                if (window.location.pathname.indexOf(page) != -1) {
                    popups_allowed = false;
                }
            });
            return popups_allowed;
        },
        stop_media_devices: async function() {
            // Get all media elements (video or audio) that might have an active media stream
            const mediaElements = document.querySelectorAll('video, audio');
            mediaElements.forEach((element) => {
                const mediaStream = element.srcObject;
                if (mediaStream) {
                    // Stop all tracks (video/audio) associated with this element
                    mediaStream.getTracks().forEach(track => track.stop());
                    // console.log("Stopped media tracks for element:", element);
                }
            });
        },
        handle_videochat: function() {
            // console.log('handle_videochat called... _current_module_page: ', _current_module_page);

            // send ajax request to remove user from videochat room when they navigate away from videochat to somewhere else
            if (_current_module_page == 'videochat:group') {
                if (window.currentRoom) {
                    currentRoom.disconnect();
                }

                util.stop_media_devices();
            }

            // if (_current_module_page == 'videochat:flussonic') {
            //     // console.log('handle_videochat found videochat:flussonic module/page');

            //     var query_string = window.location.search;
            //     // console.log('query_string: ', query_string);

            //     var url_params = new URLSearchParams(query_string);
            //     var chat_room = url_params.get('chat_room');
            //     // console.log('chat_room from url search params: ', chat_room);

            //     var url = "/members/videochat/flussonic/";

            //     var fd = new FormData();
            //     fd.append('chat_room', chat_room);
            //     fd.append('ajax_action', 'leave_room');

            //     navigator.sendBeacon(url, fd);
            // }

        }
    };

    var page_cache = {
        ids:[],
        contents:[],
        set: function(id, content) {
            // don't cache user/home, user/jump, or chat/home (will mess up redirects and browser history)
            if (id.indexOf('user/home') > -1 || id.indexOf('user/jump') > -1 || id.indexOf('chat/home') > -1) {
                return;
            }
            id = util.scrub_template_param(id);

            page_cache.ids.push(id);
            page_cache.contents.push(content);

            while (page_cache.ids.length > 3) {
                page_cache.ids.shift();
                page_cache.contents.shift();
            }
        },
        get: function(id) {
            id = util.scrub_template_param(id);

            var index = self._.indexOf(page_cache.ids,id);
            if (index >= 0) {
                return page_cache.contents[index];
            }
            return false;
        },
        del: function(id) {
            id = util.scrub_template_param(id);

            var new_ids = [];
            var new_contents = [];
            for (var i=0; i<page_cache.ids.length; i++) {
                if (page_cache.ids[i] == id) {
                    continue;
                }
                new_ids.push(page_cache.ids[i]);
                new_contents.push(page_cache.contents[i]);
            }
            page_cache.ids = new_ids;
            page_cache.contents = new_contents;
        }
    };


    var events = {
        init: function() {
            self.vent.on(self.moduleName+":redirect",this.redirect,this);
            $(window).on('resize', _.throttle(util.set_scrolling,100));

            // setup marionette/wreqr event binds for elements with data-event attributes
            $('body').on('click', '[data-event]', this.trigger_event);

            // handle all other anchor tag click events (that do not have a data-event attribute, which is handled separately)
            $('body').on('click','a:not([data-event])',this.click);

            // adding a click handler to close the ajax loader overlay
            // just in case it doesn't automatically close like it should
            $('#loading-overlay').on('click', function() {
                $(this).hide();
            });

            // add microstate to history for use in router popstate function
            self.vent.on(self.moduleName+":push_state", this.handle_push_state);

            // listen for billing_redirect events
            self.vent.on(self.moduleName+":billing_redirect", this.billing_redirect);

            // listen for pending_free_redirect events
            self.vent.on(self.moduleName+":pending_free_redirect", this.pending_free_redirect);

            // listen for handle_messaging events to close/minimize threads based on user's settings
            self.vent.on(self.moduleName+":handle_messaging", util.handle_messaging);

            // listen for handle_videochat events to cleanup/leave chat room if needed
            self.vent.on(self.moduleName+":handle_videochat", util.handle_videochat);

            var my_user = GP.sdata.my_user;
            if (my_user && my_user.get_on_top && my_user.get_on_top.on_top) {
                GP.vent.trigger('TopOfSearch:show_get_on_top');
            }
            if (my_user && my_user.stealth_mode) {
                if (my_user.stealth_paused == 'Y') {
                    GP.vent.trigger('StealthMode:stealth_mode_paused');
                } else {
                    GP.vent.trigger('StealthMode:show_stealth_mode');
                }
            }
            self.vent.on(self.moduleName+":clear_local_cache", function() {
                page_cache.ids = page_cache.contents = [];
            });
        },
        handle_push_state: function(state_obj) {
            if (MoshPit.get_size() == 'mobile' || state_obj.trending) {
                if (window.history && window.history.pushState) {
                    initial_page_load = false;
                    skip_microstate_check = false;
                    try {
                        window.history.pushState(state_obj, document.title, '');
                    } catch (e) {
                        // var error = GP.Errors.get_error(e, "pushState_error", "history.pushState failed with: ");
                        // GP.Errors.sentry.send_error(error);
                        if (typeof Sentry != 'undefined') {
                            Sentry.captureException(e, {
                                extra: {
                                    exception_location: 'Page.handle_push_state'
                                }
                            });
                        }
                    }
                }
            }
        },
        trigger_event: function(evnt) {
            // returning false from this function should call all needed
            // event.preventDefault() and stopPropagation() etc...

            initial_page_load = false;

            // grab all data-* attributes, remove the event property, and pass to handler
            var $clicked = $(evnt.currentTarget);
            var data     = $.extend({}, $clicked.data());
            var events   = data.event.split(',');
            delete data.event;

            if ($clicked.attr('href')) {
                data.href = $clicked.attr('href');
            }

            var count = 0;
            for (var i = 0; i < events.length && count < 2; i++, count++) {
                self.vent.trigger(events[i], data, $clicked);
            }

            return false;
        },
        billing_redirect: function(options) {
            var param_type = typeof options;
            var get_params = {};

            if (param_type == 'number' || param_type == 'string') {
                get_params.sduid = options;
            } else if (param_type == 'object') {
                $.extend(get_params, options);
            }
            GP.vent.trigger('Page:redirect', self.app.Util.clean_url('members/billing/join', get_params));
        },
        pending_free_redirect: function(options) {
            GP.vent.trigger('Page:redirect', self.app.Util.clean_url('members/billing/update_cc'));
        },
        click: function(e) {
            var $clicked     = $(e.currentTarget);
            var target       = $clicked.attr('target');
            var href         = $clicked.attr('href');

            // we don't want to do anything with a hash link
            if (href == '#') {
                e.preventDefault();
                return true;
            }

            // get out of here if no-follow class, or selected targets match
            if ($clicked.hasClass('no-follow') || $clicked.hasClass('download-js-link')) {
                return true;
            } else if (target && $.inArray(target.toLowerCase(), skip_targets) > -1) {
                // small optimization, but $.inArray won't get evaluated if target is empty
                return true;
            }

            // let the browser handle ctrl/command clicks (command click in mac opens in a new tab)
            if (e.metaKey || e.ctrlKey) {
                return true;
            }

            e.preventDefault();
            e.stopPropagation();

            if ($clicked.is('a') && href) {
                // elem clicked, is a link, has a dest, no target
                self.vent.trigger(self.moduleName+":redirect", href);
            }
            return false;
        },
        redirect: function(goto_url) {
            // update global flag that user has clicked something and should be able to auto play videos etc...
            _gp_user_interacted = true;

            // don't go to bunk urls
            if (goto_url === '#' || !goto_url) {
                return;
            } else if (typeof goto_url == 'object' && goto_url.url) {
                goto_url = goto_url.url;
            }

            // if (MoshPit.get_size() == 'mobile') {
            if (MoshPit.get_size() == 'mobile' && GP.request('RightDrawer:is_shown')) {
                localStorage.setItem('right_drawer_scrolltop', window.scrollY);
            }

            // redirect to http from https unless url passes allowed pages regex
            // util.handle_https(goto_url);

            initial_page_load = false;
            self.vent.trigger('Chat:cleanup', true); // cleanup anything for chat/wowza if applicable

            // cleanup videochat/leave chat room if applicable
            self.vent.trigger(self.moduleName + ":handle_videochat");

            // handle leaving games.play page with confirm and ajax call to leave game properly
            if (_current_module_page == 'games:play') {
                if (confirm("Are you sure you want to leave this page?")) {
                    var fd = new FormData();

                    // get game from current url
                    var urlParams = new URLSearchParams(window.location.search);
                    var game = urlParams.get('game');

                    fd.append('game', game);
                    fd.append('action', 'leave');
                    navigator.sendBeacon('/members/games/play', fd);

                } else {
                    return;
                }
            }

            // change goto_url to user/home from user/jump if user clicks logo/home link (since they are user/jump)
            if (goto_url === '/' || (goto_url.indexOf('user/jump') > -1 && window.location.href.indexOf('user/jump') > -1)) {
                goto_url = "/members/user/home/";
            } else if ((goto_url.indexOf('user/jump') > -1 && window.location.href.indexOf('user/jump') == -1)) {
                // ^^ if goto_url is user/jump and we aren't on user/jump, the fetch the page directly
                // if it makes it through page_reponse without a redirect, update_page will update the url/history
                if (MoshPit.get_size() == 'mobile') {
                    hit_routes.push(util.remove_domain(util.scrub_template_param(goto_url)));
                }
                apis.fetch_page(goto_url);
                return;
            }
            var url = util.remove_domain(util.scrub_template_param(goto_url));
            router.navigate(url,{trigger:true});
        },
        page_response: function(json_response) {
            if (typeof json_response != 'undefined' && json_response) {
                if (json_response.redirect) {
                    // NOTE: this will not put this page in history, so clicking back would take you 2 pages in reality
                    // if there's a case where we would need this to work, we'll have to add an exception for it
                    // and use window.location.href = ...
                    window.location.replace(json_response.redirect);
                } else if (json_response.ajax_redirect) {
                    // make sure we are pushing a blank state for redirects
                    events.handle_push_state({});

                    var url = util.remove_domain(util.scrub_template_param(json_response.ajax_redirect));
                    router.navigate(url, {trigger: true});

                    return;
                } else if (json_response.logout_redirect) {
                    window.location.href = json_response.logout_redirect;
                } else {
                    // close/hide loading overlay if not a redirect
                    util.hide_overlay();

                    // disabling page_cache.  needs to be fleshed out a little better
                    // page_cache.set(this.url, json_response);
                    events.update_page(json_response);
                }
            } else {
                util.hide_overlay();
            }
        },
        update_page: function(json, module_page) {
            $(window).scrollTop(0);
            self.$el.html(json.html);
            util.set_scrolling();

            // if we have a xhprof node in the json response, remove and insert the new xhprof html
            if (json.xhprof) {
                $("#xhprof_wrapper").remove();
                $('body').append(json.xhprof);
            }

            // if we didn't get a redirect (handled in page_response, and it's user/jump, update url/history)
            if (json.module_page == 'user:jump') {
                router.navigate('/members/user/jump/');
            }

            // Update with current module:page
            _current_module_page = json.module_page;

            // trigger the init_js:module:page event to setup page specific js
            var page_js_obj = GP.page_js[json.module_page] = {};
            self.vent.trigger('init_js:' + json.module_page, page_js_obj);

            // either update or reset current profile duid depending if user is on profile page or not
            if (json.profile_duid) {
                self.vent.trigger('Profile:update_duid', {duid: json.profile_duid});
            } else {
                self.vent.trigger('Profile:update_duid');
            }

            // trigger modal if we need it
            if (json.show_modal) {
                json.show_modal.auto_trigger = true;
                self.vent.trigger('Modal:open', json.show_modal);
            }

            // trigger reload growl if the javascript hash has changed on the server (i.e. it was updated)
            if (json.js_hash && ((json.js_hash + "") !== (_js_initial_hash + ""))) {
                self.vent.trigger('ActivityPane:add_reload_growl');
            }

            // logout of the chat page if we navigate away from it to another page
            self.vent.trigger("Chat:logout", true);

            // set current page active state on nav header
            self.vent.trigger('Header:set_active_nav');
            self.vent.trigger('NavTabBar:set_active_nav');

            // needed so external filter trigger doesn't get called
            if (_current_module_page !== 'content:trending') {
                GP.ContentTrending.first_load = false;
            }

            // process htmx elements if $el exists and htmx is loaded
            if (json.has_htmx === true && self.$el.length > 0) {
                htmx?.process(self.$el[0]);
            }
        },
        page_error: function() {
            // an error happened
            util.hide_overlay();
        }
    };


    // ensure default route (or a matching route) is called if url to navigate to is same as current url
    // only applies if trigger:true option
    // https://github.com/jashkenas/backbone/issues/652#issuecomment-15191762
    _.extend(Backbone.History.prototype, {
        refresh: function() {
            // pushing a blank state and skip microstate checking for navigating to the same url
            events.handle_push_state({});
            skip_microstate_check = true;
            this.loadUrl(this.fragment);
        }
    });
    var routeStripper = /^[#\/]/;
    var origNavigate = Backbone.History.prototype.navigate;
    Backbone.History.prototype.navigate = function (fragment, options) {
        initial_page_load = false;

        var frag = (fragment || '').replace(routeStripper, '');
        if (options && this.fragment == frag) {
            this.refresh();
        } else {
            origNavigate.call(this, fragment, options);
        }
    };
    // end backbone history hack


    this.addInitializer(function() {
        self.el  = 'page';
        self.$el = $('#' + self.el);

        $(function() {
            router = new router();
            Backbone.history.start({
                pushState:  true,
                hashChange: false,
                root:'/'
            });

            util.init();
            events.init();

            self.app.Util.gui.toggle_loading_spinner(true, 'loading-overlay', 'large');
        });
    });
});
